import styled from 'styled-components';
import { Layout } from 'antd';

/**
 * Conteúdo das páginas — superfície opaca AA.
 * Sem background-image: o axe 3.5 amostra pixels da foto e gera color-contrast falso.
 * Sem !important na cor: alto contraste global (`* { background: black }`) continua valendo.
 */
export const Content = styled(Layout.Content).attrs({
  id: 'conteudo-principal',
  tabIndex: -1,
})`
  min-height: auto;
  padding: 24px 32px;
  background-color: ${({ theme }) =>
    theme.highContrast ? 'black' : '#f5f5f5'};
  background-image: none !important;
  outline: none;

  &:focus-visible {
    box-shadow: inset 0 0 0 3px #0050b3;
  }
`;
